import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private readonly router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req).pipe(tap({
            error: err => {
                if (err instanceof HttpErrorResponse && err.status === 401 &&
                    !req.url.toLowerCase().endsWith('account/authenticatedUser'.toLowerCase()) &&
                    !req.url.toLowerCase().endsWith('account/resetPassword'.toLowerCase()) &&
                    !req.url.toLowerCase().endsWith('account/confirmEmail'.toLowerCase()) &&
                    !this.router.url.split('?')[0].toLowerCase().endsWith('configurator'.toLowerCase())) {
                    this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
                }
            }
        }));
    }
}
